import React from "react";

export default function Separator(props) {
    const className = props.className ? props.className : "";

    return (
        <div className={"separator-container " + className}>
            <div className="separator line-separator">●</div>
        </div>);
}